import React, { useMemo } from 'react'

import { Grid } from '@barracuda-internal/bds-core'

const Accounts: React.FC = () => useMemo(() => <Grid container>Hello cudaspt/accounts</Grid>, [])

export default Accounts
